import { render, staticRenderFns } from "./InventoriesMarketAreaCategoriesDialog.vue?vue&type=template&id=bf28f32c&"
import script from "./InventoriesMarketAreaCategoriesDialog.vue?vue&type=script&lang=ts&"
export * from "./InventoriesMarketAreaCategoriesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports